import React from 'react'

import { HexAvatarStyles } from './styles'

const { wrapper, svg, initial } = HexAvatarStyles

interface HexAvatarProps {
	src?: string
	userName: string
	size?: number
	strokeWidth?: number
	className?: string
}

export function HexAvatar({
	src,
	userName,
	size = 104,
	strokeWidth = 7,
	className,
}: HexAvatarProps) {
	const viewBox = '0 0 100 100'
	const patternId = `img-${userName.replace(/\s+/g, '-')}`
	const initialLetter = userName?.[0]?.toUpperCase() || '?'

	return (
		<div
			className={`${wrapper()} ${className || ''}`}
			style={{
				width: size,
				height: (size * 118) / 104,
			}}
		>
			<svg
				viewBox={viewBox}
				xmlns='http://www.w3.org/2000/svg'
				className={svg()}
			>
				<defs>
					{src && (
						<pattern
							id={patternId}
							patternUnits='userSpaceOnUse'
							width='100'
							height='100'
						>
							<image
								href={src}
								x='-25'
								width='150'
								height='100'
								preserveAspectRatio='xMidYMid slice'
							/>
						</pattern>
					)}

					<path
						id='hexRounded'
						d='
							M50,2
							Q52,3 54,4
							L92,24
							Q94,25 94,27
							L94,73
							Q94,75 92,76
							L54,96
							Q52,97 50,98
							Q48,97 46,96
							L8,76
							Q6,75 6,73
							L6,27
							Q6,25 8,24
							L46,4
							Q48,3 50,2
							Z
						'
					/>
				</defs>

				<use href='#hexRounded' fill={src ? `url(#${patternId})` : '#6BBBDC'} />

				<use href='#hexRounded' fill='none' strokeWidth={strokeWidth} />
			</svg>

			{!src && (
				<div
					className={initial()}
					style={{
						fontSize: size * 0.4,
					}}
				>
					{initialLetter}
				</div>
			)}
		</div>
	)
}
